import { render } from "./dialog.vue?vue&type=template&id=1c8986d8&scoped=true&bindings={}"
import script from "./dialog.vue?vue&type=script&lang=ts"
export * from "./dialog.vue?vue&type=script&lang=ts"

import "./dialog.vue?vue&type=style&index=0&id=1c8986d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1c8986d8"

export default script